module.exports = __webpack_public_path__ + "img/welcome-background-box.f1c9da10.svg";